if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (!this.tabs.length) return;

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });
      }

      activate(tab) {
        this.tabs.forEach((t) => {
          const selected = t === tab;
          t.classList.toggle('is-active', selected);
          t.setAttribute('aria-selected', selected ? 'true' : 'false');
          t.tabIndex = selected ? 0 : -1;
        });

        const targetId = tab.getAttribute('aria-controls');
        this.panels.forEach((panel) => {
          const show = panel.id === targetId;
          panel.hidden = !show;
          panel.classList.toggle('hidden', !show);
        });
      }

      onKeydown(event) {
        const index = this.tabs.indexOf(event.target);
        if (index === -1) return;

        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index + 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;

        event.preventDefault();
        next = (next + this.tabs.length) % this.tabs.length;
        this.activate(this.tabs[next]);
        this.tabs[next].focus();
      }
    }
  );
}
